import { computed, Directive, input } from '@angular/core';
import { IBankAccount } from '../../models';

@Directive()
export abstract class LandlordBankAccountBaseComponent {
  public bankAccount = input<IBankAccount | null>(null);

  public showCard = computed(() => {
    const account = this.bankAccount();
    if (!account) {
      return false;
    }
    return !!(account?.bankName || account?.iban || account?.bic || account?.accountOwner);
  });
}
